import { CloseWhiteIcon, Text, WarningWhiteIcon } from 'internalLibrary';
import { PropsWithChildren } from 'react';
import classNames from 'classnames';
import styles from './Notification.module.scss';

export type NotificationProps = {
  onClose?: () => void;
  text?: string;
  type: 'error' | 'success';
};

export default function Notification({
  onClose,
  text,
  type,
}: PropsWithChildren<NotificationProps>) {
  return (
    <div className={classNames(styles.notification, styles[`${type}`])}>
      {type === 'error' && (
        <span className={styles['warning-icon']}>
          <WarningWhiteIcon />
        </span>
      )}
      {!!text && (
        <Text
          className={styles.text}
          suppressDefaultStyles
          dangerouslySetInnerHTML={{ __html: text }}
        />
      )}
      <span className={styles['close-icon']}>
        <button className={styles['close-icon']} onClick={onClose}>
          <CloseWhiteIcon />
        </button>
      </span>
    </div>
  );
}
